import { render, staticRenderFns } from "./start-page.vue?vue&type=template&id=41dd95e5&scoped=true"
import script from "./start-page.vue?vue&type=script&lang=js"
export * from "./start-page.vue?vue&type=script&lang=js"
import style0 from "./start-page.vue?vue&type=style&index=0&id=41dd95e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd95e5",
  null
  
)

export default component.exports